<template lang="pug">
  
apexchart(
  ref="chart",
  type="area",
  :options="chartOptionsComputed",
  :series="series",
)

</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'c_chart_hashrate',
  props: ['options', 'series', 'preUnit', 'minimumUnit'],
  components: {
    'apexchart': VueApexCharts
  },
  data() {
    return {
      localChartOptions: {}
    }
  },
  created() {
    let vm = this
    vm.updateOptions()
  },
  computed: {
    chartOptionsComputed() {
      return this.localChartOptions
    },
    chartPeriod() {
      return this.$store.getters.chartPeriod
    },
    logChart() {
      return this.$store.getters.logChart
    }
  },
  watch: {
    options: {
      handler: function (val, oldVal) {
        let vm = this
        vm.updateOptions()
      },
      deep: true
    }
  },
  methods: {
    updateOptions() {
      let vm = this
      vm.localChartOptions = {
        ...vm.options,
        ...{
          chart: {
            ...vm.options.chart,
            toolbar: {
              ...vm.options.chart.toolbar,
              tools: {
                zoom: false,
                zoomin: false,
                zoomout: false,
                selection: true,
                reset: false,
                pan: '<span></span>',
                download: false,
                customIcons: [
                  {
                    icon: `<span class="hint hint--top-left" aria-label="Toggle past hour / past 24 hours">${vm.chartPeriod === 1 ? 'Past hour' : '24 hours'} <i class="fa fa-clock-o"></i></span>`,
                    title: 'Toggle past hour / past 24 hours',
                    class: 'custom-toolbar-button',
                    click: function () {
                      vm.$refs.chart.resetSeries();
                      let anHourAgo = new Date();
                      if (vm.chartPeriod === 1) vm.$store.dispatch('setChartPeriod', 24)
                      else vm.$store.dispatch('setChartPeriod', 1)
                      anHourAgo.setHours(anHourAgo.getHours() - vm.chartPeriod);
                      vm.options.xaxis.min = anHourAgo.getTime()
                      vm.updateOptions()
                    }
                  },
                  {
                    icon: `<span class="hint hint--top-left" aria-label="Toggle Linear / Logarithmic chart">${vm.logChart ? 'Log' : 'Linear'} <i class="fa fa-line-chart"></i></span>`,
                    title: 'Toggle Linear / Logarithmic chart',
                    class: 'custom-toolbar-button',
                    click: function () {
                      vm.$refs.chart.resetSeries();
                      vm.$store.dispatch('setLogChart', !vm.logChart)
                      vm.options.yaxis.logarithmic = vm.logChart
                      vm.updateOptions()
                    }
                  }
                ]
              }
            }
          }
        },
        ...{
          tooltip: {
            ...vm.options.tooltip,
            y: {
              formatter: (val) => { return vm.transformedUnitOfMeasurement(vm.preUnit, vm.minimumUnit, val) }
            }
          }
        }
      }
    },
    transformedUnitOfMeasurement(preUnitOfMeasurement, minimumUnitOfMeasurement, hashrate) {
      let preUnit = preUnitOfMeasurement

      let transformedHr = +hashrate
      while (+transformedHr >= 1000) {
        if (preUnit === 'z') {
          // Max unit
          break
        } else {
          if (preUnit === 'e') preUnit = 'z'
          else if (preUnit === 'p') preUnit = 'e'
          else if (preUnit === 't') preUnit = 'p'
          else if (preUnit === 'g') preUnit = 't'
          else if (preUnit === 'm') preUnit = 'g'
          else if (preUnit === 'k') preUnit = 'm'
          else if (preUnit === '') preUnit = 'k'

          transformedHr = (+transformedHr / 1000).toFixed(2)
        }
      }

      let unit = preUnit + minimumUnitOfMeasurement
      unit = unit.charAt(0).toUpperCase() + unit.slice(1);
      transformedHr = transformedHr + ' ' + unit + '/s'

      return transformedHr
    }
  }
}
</script>

<style lang="stylus">
.apexcharts-toolbar-custom-icon.custom-toolbar-button
  width: auto;
  font-size: 10px;
  font-weight: 700;
  border: solid 1px;
  line-height: 18px;
  padding: 0 5px;
  border-radius: 3px;
  margin-left 5px
</style>



// WEBPACK FOOTER //
// c_chart_hashrate.vue?546b3b61